"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _OriginalCard = _interopRequireDefault(require("./OriginalCard"));
var _hooks = require("../../helpers/hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ExpandableCard = function ExpandableCard(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    dropdownHeight = _useState4[0],
    setHeight = _useState4[1];
  var elementRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(wrapperRef, setExpanded);
  (0, _react.useEffect)(function () {
    if (elementRef.current) {
      setHeight(elementRef.current.clientHeight);
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef,
    className: (0, _classnames["default"])(expanded && '--active', 'd8-c-card-expandable', 'd8-u-relative')
  }, /*#__PURE__*/_react["default"].createElement(_OriginalCard["default"], (0, _extends2["default"])({}, props, {
    on: expanded
  }), /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    tabIndex: "0",
    role: "button",
    "aria-pressed": "false"
  }, props.header && props.header()), /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-dropdown",
    style: expanded ? {
      height: dropdownHeight
    } : {
      height: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: elementRef
  }, props.expandedContent && props.expandedContent()))));
};
ExpandableCard.propTypes = {
  expandedDescription: _propTypes["default"].string,
  header: _propTypes["default"].func.isRequired,
  expandedContent: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ExpandableCard;